import "./App.css";
import React from "react";
import HomePage from "./routes/HomePage.js";

export default function App() {
  return <HomePage />;
}

// export default App;
